import {MeshButtonContainer} from "../../components/annotations/ts/MeshButtonContainer";
import * as THREE from "three";
import {MeshButtonBase} from "../../components/annotations/ts/MeshButtonBase";
import {ColliderXContainer} from "../../components/colliders/ts/ColliderXContainer";
import {ColliderX} from "../../components/colliders/ts/ColliderX";
import * as TWEEN from "@tweenjs/tween.js";
import {CameraNavMeshHandler} from "../../components/three-gltf-loader/ts/CameraNavMeshHandler";
import {MeshObjectContainer} from "../../components/annotations/ts/MeshObjectContainer";
import CameraLocationsDataController from "../../components/zones/CameraLocationsDataController";

export class SilkRoadProcessor {

    private meshButton_StairsUpButton01: MeshButtonBase;
    private meshButton_StairsDownButton01: MeshButtonBase;

    constructor(private camera: THREE.Camera,
                private meshButtonContainer: MeshButtonContainer,
                private animatedMeshes: Array<THREE.Object3D>,
                private cameraNavMeshHandler: CameraNavMeshHandler,
                private meshObjectContainer: MeshObjectContainer,
                private scene:THREE.Scene,
                showWireframe = false) {

        this.meshButton_StairsUpButton01 = this.meshButtonContainer.getMeshButton("StairsUpButton01")!;
        this.meshButton_StairsUpButton01.onClickCallback = this.buttonClicked_StairsUpButton01;

        this.meshButton_StairsDownButton01 = this.meshButtonContainer.getMeshButton("StairsDownButton01")!;
        this.meshButton_StairsDownButton01.onClickCallback = this.buttonClicked_StairsDownButton01;
        //DownStairsLoc
        //UpStairsLoc


    }

    buttonClicked_StairsUpButton01 = (buttonId: string): void => {

        const cameraLocationRec = CameraLocationsDataController.populateCameraLocationRecordById("UpStairsLoc");
        if (cameraLocationRec && cameraLocationRec.ObjectId ) {
            const meshToNavigate = this.scene.getObjectById(cameraLocationRec.ObjectId);
            // this.cameraNavMeshHandler.navigateToNanMeshPoint(new THREE.Vector3(-5.01957 , 4, -16), () => {
            this.cameraNavMeshHandler.navigateToTargetPos(meshToNavigate!, false, () => {

            });

        }
    }

    buttonClicked_StairsDownButton01 = (buttonId: string): void => {

        const cameraLocationRec = CameraLocationsDataController.populateCameraLocationRecordById("DownStairsLoc");
        if (cameraLocationRec && cameraLocationRec.ObjectId ) {
            const meshToNavigate = this.scene.getObjectById(cameraLocationRec.ObjectId);
            // this.cameraNavMeshHandler.navigateToNanMeshPoint(new THREE.Vector3(-5.01957 , 4, -16), () => {
            this.cameraNavMeshHandler.navigateToTargetPos(meshToNavigate!, false, () => {

            });

        }
    }
}
